import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"
import cryptoJs from "crypto-js";
import settingsService from "@/_services/settings-service";
Vue.use(VueRouter)
Vue.use(cryptoJs)

const commonTags = [
  {
    name: 'viewport',
    content: 'width=device-width,minimum-scale=1,maximum-scale=1',
  },
  {
    name: 'fragment',
    content: '!',
  },
  {
    name: 'robots',
    content: 'index, follow',
  },
  {
    name: 'googlebot',
    content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
  },
  {
    name: 'bingbot',
    content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
  },
  {
    name: 'charset',
    content: 'UTF-8',
  },
  {
    property: 'og:local',
    content: 'en_US',
  },
  {
    property: 'og:type',
    content: 'website',
  },
  {
    property: 'og:url',
    content: 'http://www.ransford-solutions.com/',
  },
  {
    property: 'og:site_name',
    content:  + settingsService.get("applicationName"),
  },
  {
    property: 'article:modified_time',
    content: '2021-07-14T00:00+00.00',
  },
  {
    name: 'twitter:card',
    content: 'summary',
  },
  // {
  //   name: 'google-site-verification',
  //   content: 'K3RgKjA18sPhdoTN5DU4TsX0vXJVDhBKrgjkUOX8fJU',
  // },
];

settingsService.load();

const routes = [
  {
    path: '/unauth',
    name: 'Unauthorized',
    includeInSiteMap: false,
    meta: { authorize: [] },
    component: () =>
      import(/* webpackChunkName: "Unauth" */ '@/views/unauthorized.vue')
  },
  {
    path: "/",
    name: "Home",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Home - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Home - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/home.vue"
      ),
  },
  {
    path: '/roofing/home',
    name: 'Roofing',
    meta: { 
      authorize: [],
      title: 'Roofing - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Roofing - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content:  settingsService.get("applicationName") + ' is one of the most experienced Colorado Springs and Denver roofing contractors. We’ve been replacing and repairing roofing in Colorado Springs for over 40 years, giving our roofers the expertise necessary to handle any type of residential application. When you contact AquaDuct for assistance with your roofing project, count on our family-owned business to provide the kind of personal attention and care you can’t get from one of the big Denver roofing companies.',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/roofing/roofing-home.vue')
  },
  {
    path: '/roofing/repair',
    name: 'Roofing Repair',
    meta: { 
      authorize: [],
      title: 'Roofing Repair - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Roofing Repair - '  + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content:  settingsService.get("applicationName") +' offers prompt, professional repair of roofing in Colorado Springs, CO, and throughout metro Denver. Whether you have wind-damaged shingles, hail damage that has taken its toll, or leaks due to ice damming, we’re here to help.',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/roofing/roofing-repair.vue')
  },
  {
    path: '/roofing/replace',
    name: 'Roofing Replace',
    meta: { 
      authorize: [],
      title: 'Roofing Replace - '  + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Roofing Replace - '  + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: 'In general, most Colorado Springs roofing needs to be replaced every ten to 25 years due to normal wear and tear. However, some situations demand early replacement: building code changes, damage caused by severe weather, manufacturer defects, and so on. Occasionally roofing in Colorado Springs will leak due to some level of improper installation.',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/roofing/roofing-replace.vue')
  },
  {
    path: '/roofing/ice',
    name: 'Roofing Ice Dams',
    meta: { 
      authorize: [],
      title: 'Roofing Ice Dams - '  + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Roofing Ice Dams - '  + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/roofing/ice-dams.vue')
  },
  {
    path: '/roofing/signs',
    name: 'Roofing Signs',
    meta: { 
      authorize: [],
      title: 'Roofing Signs - '  + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Roofing Signs - '  + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/roofing/roofing-signs.vue')
  },
  {
    path: '/roofing/choose',
    name: 'Roofing Choosing',
    meta: { 
      authorize: [],
      title: 'Roofing Choosing - '  + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Roofing Choosing - '  + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/roofing/roofing-choose.vue')
  },
  {
    path: '/roofing/materials',
    name: 'Roofing Materials FAQ',
    meta: { 
      authorize: [],
      title: 'Roofing Materials FAQ - '  + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Roofing Materials FAQ - '  + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/roofing/roofing-materials.vue')
  },
  {
    path: '/gutters',
    name: 'Gutters',
    meta: { 
      authorize: [],
      title: 'Gutters - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Gutters - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/gutters/gutters-home.vue')
  },
  {
    path: '/gutters/repair',
    name: 'Gutter Repair',
    meta: { 
      authorize: [],
      title: 'Gutter Repair - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Gutter Repair - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/gutters/gutters-repair.vue')
  },
  {
    path: '/gutters/replace',
    name: 'Gutter Replace',
    meta: { 
      authorize: [],
      title: 'Gutter Replace -' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Gutter Replace - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/gutters/gutters-replace.vue')
  },
  {
    path: '/gutters/protection',
    name: 'Gutter Protection',
    meta: { 
      authorize: [],
      title: 'Gutter Protection - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Gutter Protection -' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/gutters/gutters-protection.vue')
  },
  {
    path: '/about/home',
    name: 'About Us',
    meta: { 
      authorize: [],
      title: 'About Us - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'About Us - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/about/about-home.vue')
  },
  {
    path: '/about/insurance',
    name: 'Insurance',
    meta: { 
      authorize: [],
      title: 'Insurance - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Insurance - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/about/about-insurance.vue')
  },
  {
    path: '/about/staff',
    name: 'About Staff',
    meta: { 
      authorize: [],
      title: 'Staff - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Staff - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/about/about-staff.vue')
  },
  {
    path: "/account/login",
    name: "Login",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Login - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Login - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/login.vue"
      ),
  },
  {
    path: "/account/logout",
    name: "Logout",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Logout - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Logout - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-logout" */ "@/views/account/logout.vue"
      ),
  },
  {
    path: "/account/register",
    name: "Register",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Register - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Register - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/register.vue"
      ),
  },
  {
    path: "/account/reset2",
    name: "Reset",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Reset - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Reset - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/reset.vue"
      ),
  },
  {
    path: "/account/forgot",
    name: "Forgot",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Forgot - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Forgot - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/forgot.vue"
      ),
  },
  {
    path: "/account/registered/:id",
    name: "Registered",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Registered - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Registered - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/registered.vue"
      ),
  },
  {
    path: "/account/reset",
    name: "Reset Password",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Reset Password - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Reset Password - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/reset.vue"
      ),
  },
  {
    path: "/account/loggedIn/:id",
    name: "Login",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Logged In - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Logged In - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/loggedIn.vue"
      ),
  },
  {
    path: "/account/verified/:id",
    name: "Verified",
    includeInSiteMap: false,
    meta: {
      authorize: [],
      title: "Verified - " + settingsService.get("applicationName"),
      metaTags: [
        {
          property: "og:title",
          content: "Verified - " + settingsService.get("applicationName"),
        },
        {
          property: "og:description",
          content: "",
        },
      ],
    },
      // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "account-register" */ "@/views/account/verified.vue"
      ),
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: { 
      authorize: [],
      title: 'Contact - '  + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Contact - '  + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/contact-page.vue')
  },
  {
    path: '/windows/home',
    name: 'Windows',
    meta: { 
      authorize: [],
      title: 'Windows - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Windows - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/windows/window-home.vue')
  },
  {
    path: '/windows/energy',
    name: 'Window Energy',
    meta: { 
      authorize: [],
      title: 'Windows Energy - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Windows Energy - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/windows/window-energy.vue')
  },
  {
    path: '/windows/why',
    name: 'Window Why',
    meta: { 
      authorize: [],
      title: 'Windows Why - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Windows Why - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/windows/window-replace.vue')
  },
  {
    path: '/siding/home',
    name: 'Siding',
    meta: { 
      authorize: [],
      title: 'Siding - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Siding - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/siding/siding-home.vue')
  },
  {
    path: '/siding/home',
    name: 'Siding',
    meta: { 
      authorize: [],
      title: 'Siding - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Siding - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/siding/siding-home.vue')
  },
  {
    path: '/siding/options',
    name: 'Siding Options',
    meta: { 
      authorize: [],
      title: 'Siding Options - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Siding Options - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/siding/siding-options.vue')
  },
  {
    path: '/siding/trim',
    name: 'Siding Trim Packages',
    meta: { 
      authorize: [],
      title: 'Siding Trim Packages - ' + settingsService.get("applicationName"),
      metaTags: [
        {
          property: 'og:title',
          content: 'Siding Trim Packages - ' + settingsService.get("applicationName"),
        },
        {
          property: 'og:description',
          content: '',
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/siding/trim-packages.vue')
  },
  {
    path: '/setting/estimate',
    name: 'Estimates',
    excludeFromSiteMap: true,
    meta: { authorize: [] },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/settings/estimate-list.vue')
  },
  {
    path: '/setting/estimate/:id',
    name: 'Edit Estimate',
    excludeFromSiteMap: true,
    meta: { authorize: [] },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/settings/estimate-edit.vue')
  },
  {
    path: '/setting/log',
    name: 'Logs',
    excludeFromSiteMap: true,
    meta: { authorize: [] },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import('@/views/settings/log-list.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  // // console.log("to:", to, ", from:", from, "next:", next);
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(nearestWithMeta) {
    const tags = nearestWithMeta.meta.metaTags.concat(commonTags)
    
    // Turn the meta tag definitions into actual elements in the head.
    tags.map(tagDef => {
      const tag = document.createElement('meta');

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '');

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));
  }

  const { authorize } = to.meta
  const currentUser = store.getters.getUser
  const roles = store.getters.getUserRoles
  
  if(authorize && authorize.length > 0) {
    if(!currentUser.LoggedIn) {
      return next({path: '/account/login', query: { returnUrl: to.path }})
    }

    let allowed = false
    roles.forEach(r => {
      if(authorize.includes(r.roleName)) {
        allowed = true
      }
    })
    if(!allowed) {
      return next({ path: '/unauth' })
    }
  }

  next()
})
export default router
